import { Injectable, inject } from '@angular/core';
import Config from '../utils/config.service';
import Session from '../utils/session.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';

@Injectable({ providedIn: 'root' })
export default class UrlUtil {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	createPublicUrl(translations?, fallbackLocale?, ignorePrevisit?) {
		translations = translations || {};
		fallbackLocale = fallbackLocale || 'en_GB';
		
		var user: any = this.session.getSession().user;
		var base: any;
		if (!ignorePrevisit) {
			base = user && user.previsitUser
				? this.config.getPublicWebUrlUsingDomain('minudoc.ee')
				: this.config.getBaseUrl();
		} else {
			base = this.config.getPublicWebUrlUsingDomain('minudoc.ee', true);
		}
		var language: any = (user && user.deviceLanguage) || fallbackLocale;
		
		if (translations[language]) return base + translations[language];
		if (translations[fallbackLocale]) return base + translations[fallbackLocale];
		
		return base;
	}
	
	createAvTestUrl() {
		var user: any = this.session.getSession() && this.session.getSession().user;
		var locale: any = (user && user.deviceLanguage) || 'en_GB';
		return this.createPublicUrl({
			[locale]: '/app/#/av-test?locale=' + encodeURIComponent(locale)
		}, locale);
	}
	
	createServiceUrl(service) {
		service = service || {};
		service.user = service.user || {};
		service.occupation = service.occupation;
		
		var parts: Array<any> = [];
		if (service.occupation) parts.push(service.occupation);
		if (service.user.firstname) parts.push(service.user.firstname);
		if (service.user.lastname) parts.push(service.user.lastname);
		if (service.id) parts.push(service.id);
		if (service.typeOfAppointment) parts.push(service.typeOfAppointment);

		var slug: any = parts.join('-').toLowerCase();
		slug = slug.replace(/\s/g, '-').replace(/\./g, '').replace(/öõ/g, 'o').replace(/ä/g, 'a').replace(/ü/g, 'u');
		
		return this.createPublicUrl({ 'et_EE': '/spetsialistid/' + slug, 'en_GB': '/specialists/' + slug, 'ru_RU': '/specialisty/' + slug, 'fi_FI': '/asiantuntijoita/' + slug }, undefined);
	}
	
	getSearchParams() {
		var search: any = this.angularHelperService.copy(this.angularRoutingHelperService.getQueryParams());
		if (search) {
			if (search['lang']) search['lang'] = search['lang'].split(',');
			if (search['therapies']) {
				if (typeof search['therapies'] === 'string') {
					search['therapies'] = search['therapies'].includes(',')
					? search['therapies'].split(',')
					: [search['therapies']];
				}
			}
		}
		
		return search;
	}
	
}
